<section class="expired">
  <img src="assets/images/verify_invalid_cpf_user.svg" width="200" alt="seguranca" />

  <div class="expired__title">
    <strong>Ops... Parece que esse link já expirou!</strong>
  </div>

  <p>
    <strong>Teve algum problema ou ficou com alguma dúvida?</strong>
    <br />
    <br />
    Entre em contato com o agente
    <br class="display-none-desktop" />
    ou pelo suporte Omni.
  </p>

  <br/>

  <p>
    Contatos: 0800 727 0885
  </p>
</section>
